import { useForm } from '@tanstack/react-form';
import {
  normalizeSchemaMetadataValues,
  type SchemaMetadataValues,
  toInitialMetadataDraft,
} from '../schema-metadata';
import { safeAsync } from '@morph-mapper/utils';

type UseSchemaMetadataFormOptions = {
  initialValues?: Partial<SchemaMetadataValues>;
  onError: (message: string | null) => void;
  onSubmit: (payload: SchemaMetadataValues) => Promise<void>;
};

export const useSchemaMetadataForm = ({
  initialValues,
  onError,
  onSubmit,
}: UseSchemaMetadataFormOptions) =>
  useForm({
    defaultValues: toInitialMetadataDraft(initialValues),
    onSubmit: async ({ value }) => {
      onError(null);

      const result = await safeAsync(() =>
        onSubmit(normalizeSchemaMetadataValues(value)),
      );

      if (result.isErr()) {
        onError(result.error.message);
      } else {
        onError(null);
      }
    },
  });

export type SchemaMetadataFormApi = ReturnType<typeof useSchemaMetadataForm>;
